<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :server-items-length="totalMerchants"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="id"
      fixed-header
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Nama"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.merchant_type"
              :items="listMerchantType"
              label="Type"
              item-text="text"
              item-value="value"
              @change="getData"
              @input="search.merchant_type = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.address"
              type="text"
              label="Alamat Lengkap"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.reference_number"
              type="text"
              label="Nomor Pengajuan"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Request Date"
                  v-bind="attrs"
                  @blur="search.request_date = parseDate(dateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="search.request_date"
                no-title
                scrollable
                @input="dateMenu = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenu = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.task_type"
              :items="listTaskType"
              label="Jenis Pengajuan"
              item-text="text"
              item-value="value"
              @change="getData"
              @input="search.task_type = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-autocomplete
              clearable
              v-model="search.request_by"
              :items="itemsActiveUser"
              item-text="userID"
              item-value="id"
              label="Request_by"
              :loading="loadingActiveUser"
              :search-input.sync="searchActiveUser"
              @change="getData"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.status"
              :items="listStatus"
              label="Request Status"
              item-text="text"
              item-value="value"
              @change="getData"
              @input="search.status = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />

          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="warning"
              class="mb-2"
              :style="{ 'margin-right': '10px' }"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportExcel()">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.address }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.reference_number }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.request_date }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.task_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.request_by }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.approved_by }}
          </td>

          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="viewItem(item)">
              mdi-eye
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListMerchantType,
  dataListTaskType,
  dataListHistoryMwHoStatus,
  dataDelayServiceHit,
} from '../../store/params';
import { date, showAlert } from '../../lib/helpers';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Nama',
        value: 'merchant_name',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Type',
        value: 'merchant_type',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Alamat Lengkap',
        value: 'address',
        width: '250',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Nomor Pengajuan',
        value: 'reference_number',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Request Date',
        value: 'request_date',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Jenis Pengajuan',
        value: 'task_type',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Request By',
        value: 'request_by',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Request Status',
        value: 'status',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Approved/Reject/Sendback By',
        value: 'approved_by',
        width: '280',
        align: 'start',
        sortable: false,
      },
      { text: 'Action', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    search: {
      merchant_name: '',
      mid: '',
      merchant_type: '',
      task_type: '',
      status: '',
      address: '',
      reference_number: '',
      request_by: '',
      request_date: null,
      last_update: null,
      approved_by: '',
    },
    selectedRow: '',
    listMerchantCriteria: dataListMerchantCriteria,
    listMerchantType: dataListMerchantType,
    listTaskType: dataListTaskType,
    dateMenuLastUpdate: false,
    dateFormattedLastUpdate: '',
    dateFormatted: '',
    dateMenu: false,
    listStatus: dataListHistoryMwHoStatus,
    searchActiveUser: '',
    delayHitService: null,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.daftarTugas.mw.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.daftarTugas.mw.flashError;
      },
      set() {
        this.$store.commit('daftarTugas/mw/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.daftarTugas.mw.errors;
    },
    loading() {
      return this.$store.state.daftarTugas.mw.loading;
    },
    merchants() {
      return this.$store.state.daftarTugas.mw.allMerchantsHistory;
    },
    totalMerchants() {
      return this.$store.state.daftarTugas.mw.totalMerchantsHistory;
    },
    totalPage() {
      return this.$store.state.daftarTugas.mw.totalPage;
    },
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    itemsActiveUser() {
      return this.$store.state.users.allActiveUser;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.request_date': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.request_date);
        this.getData();
      },
    },

    'search.last_update': {
      handler() {
        this.dateFormattedLastUpdate = this.formatDate(this.search.last_update);
        this.getData();
      },
    },

    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, dataDelayServiceHit);
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.merchant_type = '';
      this.search.task_type = '';
      this.search.status = '';
      this.search.address = '';
      this.search.reference_number = '';
      this.search.request_date = null;
      this.search.approved_by = '';
      this.search.last_update = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit('daftarTugas/mw/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('daftarTugas/mw/fetchMerchantsHistory', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    getActiveUser() {
      this.$store.dispatch('users/getActiveUser', {
        date,
        userID: this.searchActiveUser,
      });
    },

    viewItem(item) {
      this.$router.push(
        `/daftar-tugas/approver-1-history-list/view/${item.id}`
      );
    },

    revisiItem(item) {
      this.$router.push(`/daftar-tugas/inputer-list/edit/${item.id}`);
    },

    closeFlash() {
      this.$store.commit('daftarTugas/mw/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    exportExcel() {
      if (this.totalMerchants < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['id'],
          sortDesc: [true],
          search: this.search,
          countData: this.totalMerchants,
          module: 'history-mw-to-do-list',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: 'sql',
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
